import { StreamingActionTypes } from "./streaming.model";

export const initialState = {
    channel: "",
    uid: "",
    mode: "mix",
    resource: "",
    sid: "",
    response: {},
    isLoading: false,
    playlists: [],
    appToken: "",
    room: {},
    sessions: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case StreamingActionTypes.GET_APP_TOKEN_REQUEST:
        case StreamingActionTypes.GET_SESSIONS_REQUEST:
        case StreamingActionTypes.CREATE_ROOM_REQUEST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }

        case StreamingActionTypes.GET_SESSIONS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                sessions: action.payload,
            });
        }

        case StreamingActionTypes.GET_APP_TOKEN_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                appToken: action.payload,
            });
        }

        case StreamingActionTypes.CREATE_ROOM_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                room: action.payload,
            });
        }

        case StreamingActionTypes.CREATE_ROOM_FAILURE:
        case StreamingActionTypes.GET_SESSIONS_FAILURE:
        case StreamingActionTypes.GET_APP_TOKEN_FAILURE: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        default: {
            return state;
        }
    }
};

export { reducer as StreamingReducer };
